export default __webpack_public_path__ + "static/media/Group 1884@2x.27468beb.png";